"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const OsanoClose = () => {
    (0, react_1.useEffect)(() => {
        const dialog = document.getElementsByClassName('osano-cm-dialog')[0];
        if (dialog) {
            const btn = document.createElement('button');
            btn.className = 'os-close-btn';
            btn.innerHTML = 'Close';
            dialog.append(btn);
            btn.addEventListener('click', () => {
                dialog.style.visibility = 'hidden';
            });
        }
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.default = OsanoClose;
//# sourceMappingURL=OsanoClose.js.map